import {
  FETCH_USER_LIST,
  FETCH_USER_LIST_FAIL,
  FETCH_USER_LIST_SUCCESS
} from '../../actions/cm/users';

export const initialState = {
  isLoading: false,
  hasError: false,
  userList: []
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_USER_LIST:
      return {
        ...state,
        isLoading: true,
        hasError: false
      };
    case FETCH_USER_LIST_SUCCESS:
      return {
        ...state,
        userList: payload,
        isLoading: false
      };
    case FETCH_USER_LIST_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true
      };
    default:
      return state;
  }
}
